import {
    CaretUpFilled,
    TeamOutlined,
} from "@ant-design/icons";

import "./styles.scss";
import { logo_background_thaco } from "../../../components/ExportImgFigma";

interface StatisticCardProps {

    title: string;

    value: number | string;

    colors: [string, string];
    grow?: number | string;
    onClick?: () => void;
}

const StatisticCard = ({
    title,
    value,
    colors,
    grow,
    onClick,
}: StatisticCardProps) => {

    return (

        <div

            className="statistic-card"

            style={{

                background: `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 80%)`,
                cursor: onClick ? 'pointer' : undefined,

            }}

            onClick={onClick}

        >

            <div className="custom-page-css w-full flex flex-col gap-1">

                <div className="text-white text-sm">

                    {title}

                    <TeamOutlined className="custom-page-css pl-2" />

                </div>
                {/* <div className="custom-page-css w-full flex justify-between gap-1"> */}
                    <div className="text-white text-sm">
                        {value}
                    </div>
                     <div className="text-white text-sm" style={{minHeight: '21px'}}>
                     {grow !== undefined ? ` Chiếm ${grow}% tổng số` : ' '}
                    </div>
                {/* </div> */}
            </div>


            <div className="bg-logo">

                <img

                    src={logo_background_thaco}

                    alt="bg"

                />

            </div>

        </div >

    );

};

export default StatisticCard;